/** Shared loading placeholder for AISummaryContent and AISummaryExpanded. */
const AISummarySkeleton = () => (
  <div
    className="ai-summary-skeleton"
    role="status"
    aria-label="Loading summary"
  >
    <div className="ai-summary-skeleton-line" style={{ width: "45%" }} />
    <div className="ai-summary-skeleton-line" />
    <div className="ai-summary-skeleton-line" />
    <div className="ai-summary-skeleton-line" style={{ width: "80%" }} />
    <div className="ai-summary-skeleton-line" style={{ width: "60%" }} />
  </div>
);

export default AISummarySkeleton;
